// src/i18n/useTranslation.js
import { useState, useEffect, createContext, useContext } from 'react';

const I18nContext = createContext(null);

export const I18nProvider = ({ children, initialLanguage = 'en' }) => {
  const [translations, setTranslations] = useState({});
  const [currentLanguage, setCurrentLanguage] = useState(initialLanguage);

  useEffect(() => {
    const loadTranslations = async () => {
      try {
        const module = await import(`./locales/${currentLanguage}.json`);
        setTranslations(module.default);
      } catch (error) {
        console.error(`Failed to load translations for ${currentLanguage}:`, error);
        // Fallback to a default language if loading fails
        const fallbackModule = await import(`./locales/en.json`);
        setTranslations(fallbackModule.default);
      }
    };
    loadTranslations();
  }, [currentLanguage]);

  const t = (key) => {
    return translations[key] || key; // Return key if translation not found
  };

  return (
    <I18nContext.Provider value={{ t, currentLanguage, setCurrentLanguage }}>
      {children}
    </I18nContext.Provider>
  );
};

export const useTranslation = () => {
  const context = useContext(I18nContext);
  if (!context) {
    throw new Error('useTranslation must be used within an I18nProvider');
  }
  return context;
};